import React from 'react';
import CustomFieldsTab from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/CustomFieldsTab/index';
import { CustomFieldsWrapper } from '../General/styled';

const CustomFields = () => (
  <CustomFieldsWrapper>
    <CustomFieldsTab />
  </CustomFieldsWrapper>
);

export default CustomFields;
